import React, { useState } from "react";
import theme from "../../theme";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  TextField,
  //IconButton,
  InputAdornment,
  TableSortLabel,
} from "@mui/material";
import { Search } from "@mui/icons-material";
//import { Search, FilterList } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { Selector } from "./selector";
import styled from "styled-components";
import { convertToLocalCurrency } from "../../utils/currency";
import { format } from "date-fns";

const SelectorWrap = styled.div`
  position: relative;
  .dropdown-content {
    visibility: hidden;
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #fff;
    min-width: 100%;
    font-size: 12px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
    z-index: 10;
    overflow-x: hidden;
    opacity: 0;
    max-height: 0;
    transition: max-height 0.6s ease, opacity 0.2s ease, visibility 0.2s ease;

    a {
      color: #000;
      padding: 10px 20px;
      text-decoration: none;
      display: block;
      text-align: left;

      &:hover {
        background-color: #f1f1f1;
      }
    }
  }

  &:hover .dropdown-content {
    visibility: visible;
    opacity: 1;
    max-height: 300px;
    margin-bottom: 20px !important;
    transition: max-height 0.6s ease, opacity 0.2s ease, visibility 0.2s ease;
  }
`;
const StatusLabel = styled.span`
  display: inline-block;
  font-size: 12px;
  padding: 10px 20px;
  border-radius: 16px;
  font-weight: bold;
  text-align: center;

  color: ${({ isActive }) => (isActive ? "#027A48" : "#B42318")};

  background-color: ${({ isActive }) => (isActive ? "#ECFDF3" : "#FEF3F2")};
`;
const ApprovalLabel = styled.span`
  display: inline-block;
  font-size: 12px;
  font-weight: bolder;
  text-align: center;
  span {
    font-size: 15px;
  }
  color: ${({ isApproved, status }) =>
    isApproved === "APPROVED" || status === "APPROVED" || isApproved === "PAID"
      ? theme.color.brand
      : isApproved === "REJECTED" || status === "REJECTED"
      ? "#FF2D55"
      : "#AF52DE"};
`;

const Container = styled.div`
  display: flex;
  gap: 10px;

  .export-button {
    padding: 8px 16px;
    background-color: ${theme.color.brand};
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    margin-left: 10px;
    
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
`;

const GenericTableComponent = ({
  columns,
  data,
  filterSearch,
  paginate,
  viewLink,
  editLink,
  page,
  rowsPerPage,
  handlePageChange,
  handleRowsPerPageChange,
  totalItems,
  handleSearchChange,
  triggerSearch,
  search,
  reportView,
  dailyView,
  showExport,
  onExport,
  exportLoading,
  hideSearch,
  billingView,
  showModal,
  hideEdit,
  hideView,
  hideSelector
}) => {
  //const [search, setSearch] = useState("");

  // const handleSearchChange = (event) => {
  //   setSearch(event.target.value);
  // };

  // const data = data.filter((row) => {
  //   return columns.some((column) =>
  //     row[column.id]?.toString().toLowerCase().includes(search.toLowerCase())
  //   );
  // });
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (orderBy) {
      if (order === "asc") {
        return a[orderBy] < b[orderBy] ? -1 : 1;
      } else {
        return a[orderBy] > b[orderBy] ? -1 : 1;
      }
    }
    return 0;
  });

  const formatMonthYear = (monthValue, yearValue) => {
    // Accepts either a single "Month Year" string or separate month/year values
    let month = monthValue;
    let year = yearValue;

    if (!year && typeof monthValue === "string") {
      const parts = monthValue.trim().split(/\s+/);
      if (parts.length >= 2) {
        [month, year] = parts;
      }
    }

    const monthMap = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    const normalizedMonth =
      typeof month === "number" || /^\d+$/.test(month)
        ? String(month).padStart(2, "0")
        : monthMap[month] || "";
    const normalizedYear = year ? String(year).slice(-2) : "";

    return normalizedMonth && normalizedYear
      ? `${normalizedMonth}-${normalizedYear}`
      : "";
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
      {filterSearch && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "16px",
            //marginBottom: "20px",
            // overflow: "visible",
            // overflowX: "auto",
          }}
        >
          {hideSearch ? <div></div> : ""}
          {hideSearch ? (
            ""
          ) : (
            <TextField
              label="Search by name"
              variant="outlined"
              size="small"
              value={search}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search
                      onClick={triggerSearch}
                      style={{ cursor: "pointer" }}
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: theme.color.brand,
                  },
                },
                "& .MuiInputLabel-root": {
                  "&.Mui-focused": {
                    color: theme.color.brand,
                  },
                },
              }}
            />
          )}
          <Container>
            {showExport ? (
              <button 
                className="export-button"
                onClick={onExport}
                disabled={exportLoading}
              >
                {exportLoading ? 'Exporting...' : 'Export CSV'}
              </button>
            ) : null}
          </Container>
        </div>
      )}
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  sx={{
                    border: "none",
                    backgroundColor: "#F0F1F3",
                    fontWeight: "500",
                    letterSpacing: "1",
                    fontSize: "13px",
                    color: "#48505E",
                  }}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : "asc"}
                    onClick={() => handleRequestSort(column.id)}
                    hideSortIcon={false}
                    sx={{
                      "& .MuiTableSortLabel-icon": {
                        color: "#578881 !important",
                        opacity: "1 !important",
                        height: "13px",
                      },
                    }}
                  >
                    {column.label}
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell
                sx={{
                  border: "none",
                  backgroundColor: "#F0F1F3",
                  fontWeight: "500",
                  fontSize: "13px",
                  color: "#48505E",
                }}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((row, index) => (
              <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                {columns.map((column) => (
                  <TableCell
                    sx={{
                      backgroundColor: "#ffff",
                      border: "none",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "#667085",
                    }}
                    key={column.id}
                  >
                    {(column.id === "campaignName" || column.id === "campaignname") && row.photoUrl ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={row.photoUrl[0].url}
                          alt={row.name}
                          style={{ width: 40, height: 40, marginRight: 10 }}
                        />
                        {row[column.id]}
                      </div>
                    ) : column.id === "monthYear" ? (
                      row.monthYear ||
                      [row.month, row.year].filter(Boolean).join(" ")
                    ) : column.id === "isActive" ? (
                      <StatusLabel isActive={row[column.id]}>
                        {row[column.id] ? "Active" : "Inactive"}
                      </StatusLabel>
                      ) : (column.id === "isApproved" || 
                        column.id === "isapproved") ||
                        column.id === "status" ? (
                        <ApprovalLabel isApproved={row[column.id]}>
                          <span>●</span> {row[column.id]}
                        </ApprovalLabel>
                         ) : (column.id === "isApproved" || column.id === "isapproved") &&
                         row?.isActive === false ? (
                         <ApprovalLabel isApproved={row.isApproved}>
                           <span>●</span> {row.isApproved} - PAUSED
                         </ApprovalLabel>
                    // ) : column.id === "isApproved" ? (
                    //   <StatusLabel isApproved={row[column.id]}>
                    //     {row[column.id] ? "Approved" : "Unapproved"}
                    //   </StatusLabel>
                    ) : column.id === "conversion_rate" ||
                      column.id === "conversionRate" || column.id === "conversionrate" ? (
                      row[column.id] + "%"
                    ) : column.id === "amountSpent" || column.id === "amountspent" ? (
                      convertToLocalCurrency(row[column.id])
                    ) : column.id === "campaignBudget" || 
                    column.id === "campaignbudget" ||
                    column.id === "totalAmount" ||
                    column.id === "amountPaid" ? (
                      convertToLocalCurrency(row[column.id])
                    ): column.id === "day" ||
                    column.id === "paidAt" ||
                    column.id === "createdAt"  ? (
                      format(new Date(row[column.id]), "dd-MM-yyyy")
                    ) 
                    : (
                      row[column.id]
                    )}
                  </TableCell>
                ))}
                <TableCell sx={{ border: "none", backgroundColor: "#ffff" }}>
                  {billingView ? (
                    <SelectorWrap>
                      <Selector />
                      <div className="dropdown-content">
                        <Link onClick={() => showModal(row.id)}>View</Link>
                      </div>
                    </SelectorWrap>
                  ) : reportView ? (
                    <SelectorWrap>
                      <Selector />
                      <div className="dropdown-content">
                        <Link
                          to={`${viewLink}/${formatMonthYear(
                            row.month ?? row.monthYear,
                            row.year
                          )}?date=${encodeURIComponent(`${row.month} ${row.year}`)}`}
                        >
                          View
                        </Link>
                      </div>
                      </SelectorWrap>
                  ) : dailyView ? (
                    <SelectorWrap>
                      <Selector />
                      <div className="dropdown-content">
                        <Link 
                          to={`${viewLink}?startDate=${format(row.day, "yyyy-MM-dd")}&endDate=${format(row.day, "yyyy-MM-dd")}`}
                        >
                          View Campaigns
                        </Link>
                      </div>
                      </SelectorWrap>
                  ) : hideSelector ? (
                        ""
                  ) : (
                    <SelectorWrap>
                      <Selector />
                      <div className="dropdown-content">
                        {hideView ? (
                          ""
                        ) : (
                          <Link to={`${viewLink}/${row.id}`}>View</Link>
                        )}
                        {hideEdit ? (
                          ""
                        ) : (
                          <Link to={`${editLink}/${row.id}`}>Edit</Link>
                        )}
                      </div>
                    </SelectorWrap>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {paginate && (
        <TablePagination
          rowsPerPageOptions={[5, 10]}
          component="div"
          count={totalItems}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}
    </Paper>
  );
};

export default GenericTableComponent;
